import { useContext } from 'react';

import {
	ServiceWorkerContext,
	ServiceWorkerContextType,
} from '@/services/sw/sw.context';

/**
 * React hook that returns the navigator service worker
 *
 * @return {ServiceWorkerContextType} The service worker
 */
export function useServiceWorker(): ServiceWorkerContextType {
	const context = useContext(ServiceWorkerContext);
	if (context === undefined) {
		throw new Error(
			'useServiceWorkerContext must be used within a ServiceWorkerProvider',
		);
	}
	return context;
}
